import type React from 'react';
import { useEffect } from 'react';
import useInput from '@hooks/useInput';
import Modal from '../Modal';
import Button from '../Button';
import Input from '../Input';
import Title from '../Title';

interface Props {
  initialValue?: string;
  isOpen?: boolean;
  maxLength?: number;
  placeholder?: string;
  title: string;
  allowEmpty?: boolean;
  cancelText?: string;
  loading?: boolean;
  onRequestClose: () => void;
  onConfirm: (val: string) => void;
}

function InputModal({
  initialValue,
  isOpen = false,
  maxLength,
  placeholder,
  title,
  allowEmpty = false,
  cancelText,
  loading = false,
  onRequestClose,
  onConfirm,
}: Props) {
  const input = useInput<HTMLInputElement>(initialValue);
  const disabled = (!allowEmpty && !input.value) || loading;
  useEffect(() => {
    if (isOpen) {
      input.select();
      return () => {
        input.clear();
      };
    }
  }, [isOpen]);
  const handleConfirm = () => {
    onConfirm(input.value.trim());
  };
  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (disabled) return;
    if (event.key === 'Enter') {
      handleConfirm();
    }
  };
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      cancelText={cancelText}
      header={<Title>{title}</Title>}
      footer={
        <Button disabled={disabled} onClick={handleConfirm}>
          确认操作
        </Button>
      }
    >
      <div className="flex h-full items-center">
        <Input
          className="h-40 w-full"
          disabled={loading}
          maxLength={maxLength}
          placeholder={placeholder}
          onClear={() => {
            input.clear();
            input.focus();
          }}
          onKeyDown={handleKeyDown}
          {...input.bind}
        />
      </div>
    </Modal>
  );
}

export default InputModal;
